export default __webpack_public_path__ + "static/media/no-data.e66e6898.png";